// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jPxn","footer":"styles_footer__2ZjH4","passCodeTooltip":"styles_passCodeTooltip__1qgjO"};